import type { RoleEnum } from '@zeus/index'
import { useQuery } from '@apollo/client/react'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { Button } from '~/components/ui/button'
import { GQL_LOGIN_UNIQUE } from '~/gql/auth/auth'
import { env } from '~/helpers/env'
import { useAuth } from '~/helpers/store/auth'
import { getDefaultRoute } from '~/routes/router'

function LoginSSO() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const { setPayload, setLoading } = useAuth()
  const jwt = searchParams.get('jwt')
  const uniqueCode = searchParams.get('uniqueCode')
  const hasNavigated = useRef(false)

  const { data } = useQuery(GQL_LOGIN_UNIQUE, {
    variables: {
      code: uniqueCode as string,
    },
    skip: !uniqueCode,
  })

  useEffect(() => {
    if (jwt && uniqueCode && data?.uniqueAuthFromSso && !hasNavigated.current) {
      hasNavigated.current = true
      toast.success(t('connection.successful'))

      setPayload({
        firstName: data.uniqueAuthFromSso.firstName,
        lastName: data.uniqueAuthFromSso.lastName,
        email: data.uniqueAuthFromSso.email,
        role: data.uniqueAuthFromSso.role,
        id: data.uniqueAuthFromSso.id,
      })
      setLoading(false)

      navigate(getDefaultRoute(data.uniqueAuthFromSso.role as RoleEnum))
    }
  }, [jwt, uniqueCode, data, navigate, setPayload, setLoading, t])

  return (
    <Button
      variant="outline"
      type="button"
      onClick={() => (location.href = `${env.api.url}/auth/saml/login`)}
      className="font-heading tracking-wide"
    >
      {t('login.sso')}
    </Button>
  )
}

export default LoginSSO
